import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UserLevelComponent } from '@core/components/user-level/user-level.component';
import { ChatEmotePipe } from '../pipes/chat-emote.pipe';
import { SessionService } from '@core/services/session.service';
import { ContextMenuService } from '@core/services/context-menu.service';
import { ChatMessage } from '../interfaces/chat.interface';
import { ClipboardService } from '@core/services/clipboard.service';
import { ADMIN_LEVELS as levels } from '@core/constants/admin-levels.constants';
import { SupplyDropMessageComponent } from '../supply-drop-message/supply-drop-message.component';

interface ExtraFeature {
  title: string;
  action?: (message: ChatMessage) => void;
}

interface ExtraBadges {
  title: string;
}

@Component({
  selector: 'app-chat-message',
  imports: [UserLevelComponent, ChatEmotePipe, SupplyDropMessageComponent],
  templateUrl: './chat-message.component.html',
  standalone: true,
  styleUrl: './chat-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.outlined]': 'message().__outlined',
  },
})
export class ChatMessageComponent {
  readonly ADMIN_LEVELS = levels;
  message = input.required<ChatMessage>();

  showContextMenu = input(true);
  adminFeatures = input<ExtraFeature[]>([]);
  messageFeatureBadges = input<ExtraBadges[]>([]);

  constructor(
    public sessionService: SessionService,
    public contextMenuService: ContextMenuService,
    public clipboardService: ClipboardService
  ) {}

  isSupplyDropMessage(): boolean {
    const start = this.message().__supplyDropStart;
    const end = this.message().__supplyDropEnd;
    return (
      (!!start && start.caseName.toLowerCase().includes('bronze')) ||
      (!!end && end.caseName.toLowerCase().includes('bronze'))
    );
  }
}
